import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { DubaiPin } from "../../../../app-constants";
import FaqComponents from "../../components/common/faq";

const faqs = [
  {
    question: "What is an app Marketing?",
    answer: `<p>App marketing is the process of branding a mobile app to reach a global audience and increase downloads. The process occurs through different channels including social media, ASO, influencer marketing, email marketing, and online advertisements.</p>`,
  },
  {
    question: "What does an app marketing agency do?",
    answer: ` <p>A marketing agency specializing in app promotion creates and implements personalized marketing plans to enhance the visibility of your app, attract users, and enhance engagement. Through a combination of optimizing your app store presence, employing user acquisition strategies, and analyzing data, they work towards achieving the growth goals for your app.</p>`,
  },
  {
    question: "How much does a marketing agency cost in Dubai?",
    answer: `<p>The cost of app marketing agency in Dubai may vary according to the scale of the business and the services that an agency offers based on its resources. However, here is a common costing structure for different app marketing services.</p>  
        <ul>
        <li>Digital marketing packages: <strong>AED 5,000 to AED 15,000</strong></li>
        <li>Agency costs between: <strong>AED 5,000 to AED 20,000</strong></li>
        <li>SEO: <strong>AED 2,500 to AED 5,000</strong></li>
        <li>Social media marketing: <strong>AED 5,000 to AED 10,000</strong></li>
    </ul>`,
  },
  {
    question: "How do I attract more users to my apps?",
    answer: `<p>Here are some of the most effective app marketing strategies to gain new users:</p>
        <ul>
        <li>Build a strong marketing campaign</li>
        <li>Focus on app store optimization</li>
        <li>Ask your most loyal users for reviews</li>
        <li>Use paid advertising</li>
        <li>Leverage social media to the fullest</li>
        <li>Offer a demo or freemium model</li>
        </ul>`,
  },
  {
    question: "Why is app promotion important?",
    answer: `<p>The fundamental goal of mobile app marketing is to regularly connect with smartphone users through personalized notifications or advertisements, ensuring constant awareness. To stay competitive and avoid falling behind your rivals, it's crucial to join the most prominent trend in mobile app marketing.</p> `,
  },
  {
    question: "How much should a company pay for marketing?",
    answer: `<p>A marketing budget typically falls within the range of 5 to 25 percent of a company's revenue or revenue targets. The specific percentage is influenced by various factors, including the size of the company, its stage of growth, and the significance of marketing in driving sales within its industry, among other considerations.</p>`,
  },
  {
    question:
      " Why Should I Choose TekRevol over other marketing companies in Dubai?",
    answer: `<p>Choosing TekRevol over other app marketing companies in Dubai has a significant advantage as you receive personalized and all-encompassing app marketing strategy solutions that cater to your specific requirements. Our team of professional marketers is committed to delivering efficient and result-oriented services to uphold the mobile apps of diverse businesses. Our dedication to quality and excellence guarantees dependable app promotion services. Additionally, we offer cost-effective solutions, ensuring that you receive optimal value for your investment.</p>`,
  },
  {
    question:
      "How does a well-designed mobile app for marketing contribute to a brand's overall digital strategy?",
    answer: `<p>A well-designed mobile app for marketing plays an important role in a brand's digital strategy by offering a direct and personalized channel to engage with consumers. It enhances brand visibility, improves customer satisfaction through tailored experiences, and facilitates seamless interactions.</p>`,
  },
];

function FaqLocation(props) {
  return (
    <div className="faq_loc p-100 tekrevol_dark_bg">
      <Container className="h-100">
        <Row className="h-100">
          <Col
            xs={12}
            md={12}
            lg={12}
            xl={10}
            xxl={10}
            className="m-auto text-center"
          >
            <div className="example center text-center" data-text="FAQs">
              <h2>Frequently Asked Questions</h2>
            </div>
          </Col>
        </Row>
        <Row className="h-100">
          <Col xs={12} md={12} lg={8} xl={7} xxl={7} className="services_faqs">
            <FaqComponents faqs={faqs} />
          </Col>

          <Col xs={12} md={12} lg={4} xl={4} xxl={4} className="offset-xl-1">
            <div className="map_loc">{DubaiPin}</div>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default FaqLocation;
